export const modulesConstants = {
  SET_ROOT_MODULE: 'SET_ROOT_MODULE'
};